import React from 'react';
import { Badge } from 'react-bootstrap';

import RetencionesMasivasTicketStatus from '../../enum/RetencionesMasivasTicketStatus';

const RetencionesMasivasTicketsRenderStatus = ({ item }) => {
  let variant = 'light';

  const status = RetencionesMasivasTicketStatus.search(item.status) || RetencionesMasivasTicketStatus.undefined();

  if (status.isSuccess()) {
    variant = 'success';
  } else if (status.isCancelled() || status.isError() || status.isFailed()) {
    variant = 'danger';
  } else if (!status.isPending()) {
    variant = 'info';
  }

  return <Badge variant={variant}>{status.getName()}</Badge>;
};

export default RetencionesMasivasTicketsRenderStatus;
